var _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _path3, _path4, _path5, _path6, _path7, _path8, _rect16, _rect17, _g, _rect18, _g2, _rect19, _g3, _rect20, _g4, _rect21, _g5, _rect22, _g6, _rect23, _g7, _rect24, _rect25, _g8, _rect26, _g9, _rect27, _g10, _rect28, _g11, _rect29, _g12, _rect30, _g13, _rect31, _g14, _rect32, _rect33, _g15, _rect34, _g16, _rect35, _g17, _rect36, _g18, _rect37, _g19, _rect38, _g20, _rect39, _g21, _rect40, _rect41, _g22, _rect42, _g23, _rect43, _g24, _rect44, _g25, _rect45, _g26, _rect46, _g27, _rect47, _g28, _rect48, _rect49, _g29, _rect50, _g30, _rect51, _g31, _rect52, _g32, _rect53, _g33, _rect54, _g34, _rect55, _g35, _rect56, _rect57, _g36, _rect58, _g37, _rect59, _g38, _rect60, _g39, _rect61, _g40, _rect62, _g41, _rect63, _g42, _path9, _g43;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgDataViewGraphmetric = function SvgDataViewGraphmetric(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 99,
    viewBox: "0 0 160 99",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 159,
    height: 98,
    rx: 2.5,
    fill: "white",
    stroke: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95 30.2222H151",
    stroke: "#E2E2EA",
    strokeWidth: 0.180645,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95 18.0287H151",
    stroke: "#E2E2EA",
    strokeWidth: 0.180645,
    strokeLinecap: "square"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 99.8981,
    y: 23.6774,
    width: 5.69032,
    height: 1.17419,
    rx: 0.587097,
    fill: "currentColor"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 95.0208,
    y: 28.1935,
    width: 5.23871,
    height: 1.17419,
    rx: 0.587097,
    fill: "currentColor"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 95.0208,
    y: 16,
    width: 7.49677,
    height: 1.17419,
    rx: 0.587097,
    fill: "currentColor"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 99.8981,
    y: 35.9614,
    width: 5.69032,
    height: 1.17419,
    rx: 0.587097,
    fill: "currentColor"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 117.33,
    y: 35.9614,
    width: 5.69032,
    height: 1.17419,
    rx: 0.587097,
    fill: "currentColor"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 135.846,
    y: 35.9614,
    width: 5.69032,
    height: 1.17419,
    rx: 0.587097,
    fill: "currentColor"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 135.846,
    y: 23.6774,
    width: 5.69032,
    height: 1.17419,
    rx: 0.587097,
    fill: "currentColor"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 117.33,
    y: 23.6774,
    width: 5.69032,
    height: 1.17419,
    rx: 0.587097,
    fill: "currentColor"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 98.0015,
    y: 19.7935,
    width: 9.30323,
    height: 1.17419,
    rx: 0.587097,
    fill: "currentColor"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 134.04,
    y: 19.7935,
    width: 9.30323,
    height: 1.17419,
    rx: 0.587097,
    fill: "currentColor"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 115.524,
    y: 19.7935,
    width: 9.30323,
    height: 1.17419,
    rx: 0.587097,
    fill: "currentColor"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 98.0015,
    y: 32.0775,
    width: 9.30323,
    height: 1.17419,
    rx: 0.587097,
    fill: "currentColor"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 134.04,
    y: 32.0775,
    width: 9.30323,
    height: 1.17419,
    rx: 0.587097,
    fill: "currentColor"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 115.524,
    y: 32.0775,
    width: 9.30323,
    height: 1.17419,
    rx: 0.587097,
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10156 62.967L148.451 62.9358",
    stroke: "#E2E2EA",
    strokeWidth: 0.101493,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10156 56.0664L148.451 56.0351",
    stroke: "#E2E2EA",
    strokeWidth: 0.101493,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 84.8894H148.552",
    stroke: "#E2E2EA",
    strokeWidth: 0.101493,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9 73.9282H148.552",
    stroke: "#E2E2EA",
    strokeWidth: 0.101493,
    strokeLinecap: "square"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9 79.4089H148.552",
    stroke: "#E2E2EA",
    strokeWidth: 0.101493,
    strokeLinecap: "square"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9 68.4328H148.552",
    stroke: "#E2E2EA",
    strokeWidth: 0.101493,
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1403_19289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 58,
    width: 13,
    height: 3
  }, _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9583,
    y: 58.8418,
    width: 9.74328,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2686,
    y: 58.8418,
    width: 1.52239,
    height: 1.52239,
    rx: 0.304478,
    fill: "#ECECEC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1403_19289)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 57.3193,
    width: 17.7612,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1403_19289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 58,
    width: 11,
    height: 3
  }, _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 35.3879,
    y: 58.8418,
    width: 9.74328,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1403_19289)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.8059,
    y: 57.3193,
    width: 16.3403,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1403_19289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 58,
    width: 14,
    height: 3
  }, _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7881,
    y: 58.8418,
    width: 13.194,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1403_19289)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.2061,
    y: 57.3193,
    width: 19.791,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1403_19289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 58,
    width: 8,
    height: 3
  }, _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 79.6389,
    y: 58.8418,
    width: 6.69851,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1403_19289)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.0566,
    y: 57.3193,
    width: 13.2955,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1403_19289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 58,
    width: 8,
    height: 3
  }, _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 96.9939,
    y: 58.8418,
    width: 6.69851,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1403_19289)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.4121,
    y: 57.3193,
    width: 13.2955,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1403_19289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 58,
    width: 14,
    height: 3
  }, _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 114.349,
    y: 58.8418,
    width: 13.194,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1403_19289)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.767,
    y: 57.3193,
    width: 19.791,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1403_19289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 58,
    width: 7,
    height: 3
  }, _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 138.2,
    y: 58.8418,
    width: 6.69851,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1403_19289)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.618,
    y: 57.3193,
    width: 13.2955,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1403_19289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 64,
    width: 13,
    height: 3
  }, _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9583,
    y: 64.9313,
    width: 9.74328,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2686,
    y: 64.9314,
    width: 1.52239,
    height: 1.52239,
    rx: 0.304478,
    fill: "#ECECEC"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1403_19289)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 63.4089,
    width: 17.7612,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_1403_19289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 64,
    width: 14,
    height: 3
  }, _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 35.3879,
    y: 64.9314,
    width: 12.7881,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_1403_19289)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.8059,
    y: 63.4089,
    width: 19.3851,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_1403_19289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 64,
    width: 11,
    height: 3
  }, _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7881,
    y: 64.9314,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_1403_19289)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.2061,
    y: 63.4089,
    width: 16.7463,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_1403_19289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 64,
    width: 10,
    height: 3
  }, _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 79.6389,
    y: 64.9314,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_1403_19289)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.0566,
    y: 63.4089,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_1403_19289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 64,
    width: 10,
    height: 3
  }, _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 96.9939,
    y: 64.9314,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_1403_19289)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.4121,
    y: 63.4089,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_1403_19289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 64,
    width: 11,
    height: 3
  }, _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 114.349,
    y: 64.9314,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_1403_19289)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.767,
    y: 63.4089,
    width: 16.7463,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_1403_19289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 64,
    width: 9,
    height: 3
  }, _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 138.2,
    y: 64.9314,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_1403_19289)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.618,
    y: 63.4089,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_1403_19289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 70,
    width: 13,
    height: 2
  }, _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9583,
    y: 70.412,
    width: 9.74328,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2686,
    y: 70.4121,
    width: 1.52239,
    height: 1.52239,
    rx: 0.304478,
    fill: "#ECECEC"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_1403_19289)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 68.8896,
    width: 17.7612,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_1403_19289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 70,
    width: 14,
    height: 2
  }, _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 35.3879,
    y: 70.4121,
    width: 12.7881,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_1403_19289)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.8059,
    y: 68.8896,
    width: 19.3851,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_1403_19289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 70,
    width: 11,
    height: 2
  }, _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7881,
    y: 70.4121,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_1403_19289)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.2061,
    y: 68.8896,
    width: 16.7463,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_1403_19289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 70,
    width: 10,
    height: 2
  }, _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 79.6389,
    y: 70.4121,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_1403_19289)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.0566,
    y: 68.8896,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_1403_19289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 70,
    width: 10,
    height: 2
  }, _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 96.9939,
    y: 70.4121,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_1403_19289)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.4121,
    y: 68.8896,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_1403_19289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 70,
    width: 11,
    height: 2
  }, _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 114.349,
    y: 70.4121,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_1403_19289)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.767,
    y: 68.8896,
    width: 16.7463,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_1403_19289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 70,
    width: 9,
    height: 2
  }, _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 138.2,
    y: 70.4121,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_1403_19289)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.618,
    y: 68.8896,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_1403_19289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 75,
    width: 13,
    height: 3
  }, _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9583,
    y: 75.994,
    width: 9.74328,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2686,
    y: 75.9939,
    width: 1.52239,
    height: 1.52239,
    rx: 0.304478,
    fill: "#ECECEC"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_1403_19289)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 74.4717,
    width: 17.7612,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_1403_19289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 75,
    width: 14,
    height: 3
  }, _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 35.3879,
    y: 75.9939,
    width: 12.7881,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_1403_19289)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.8059,
    y: 74.4717,
    width: 19.3851,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_1403_19289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 75,
    width: 11,
    height: 3
  }, _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7881,
    y: 75.9939,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_1403_19289)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.2061,
    y: 74.4717,
    width: 16.7463,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_1403_19289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 75,
    width: 10,
    height: 3
  }, _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 79.6389,
    y: 75.9939,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_1403_19289)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.0566,
    y: 74.4717,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_1403_19289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 75,
    width: 10,
    height: 3
  }, _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 96.9939,
    y: 75.9939,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_1403_19289)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.4121,
    y: 74.4717,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_1403_19289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 75,
    width: 11,
    height: 3
  }, _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 114.349,
    y: 75.9939,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_1403_19289)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.767,
    y: 74.4717,
    width: 16.7463,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_1403_19289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 75,
    width: 9,
    height: 3
  }, _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 138.2,
    y: 75.9939,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_1403_19289)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.618,
    y: 74.4717,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_1403_19289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 81,
    width: 13,
    height: 2
  }, _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9583,
    y: 81.4746,
    width: 9.74328,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2686,
    y: 81.4746,
    width: 1.52239,
    height: 1.52239,
    rx: 0.304478,
    fill: "#ECECEC"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_1403_19289)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 79.9521,
    width: 17.7612,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_1403_19289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 81,
    width: 14,
    height: 2
  }, _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 35.3879,
    y: 81.4746,
    width: 12.7881,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_1403_19289)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.8059,
    y: 79.9521,
    width: 19.3851,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_1403_19289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 81,
    width: 11,
    height: 2
  }, _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7881,
    y: 81.4746,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_1403_19289)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.2061,
    y: 79.9521,
    width: 16.7463,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_1403_19289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 81,
    width: 10,
    height: 2
  }, _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 79.6389,
    y: 81.4746,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_1403_19289)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.0566,
    y: 79.9521,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_1403_19289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 81,
    width: 10,
    height: 2
  }, _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 96.9939,
    y: 81.4746,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_1403_19289)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.4121,
    y: 79.9521,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_1403_19289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 81,
    width: 11,
    height: 2
  }, _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 114.349,
    y: 81.4746,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_1403_19289)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.767,
    y: 79.9521,
    width: 16.7463,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_1403_19289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 81,
    width: 9,
    height: 2
  }, _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 138.2,
    y: 81.4746,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_1403_19289)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.618,
    y: 79.9521,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_1403_19289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 86,
    width: 13,
    height: 3
  }, _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9583,
    y: 86.9551,
    width: 9.74328,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2686,
    y: 86.9551,
    width: 1.52239,
    height: 1.52239,
    rx: 0.304478,
    fill: "#ECECEC"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_1403_19289)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 85.4329,
    width: 17.7612,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_1403_19289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 86,
    width: 14,
    height: 3
  }, _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 35.3879,
    y: 86.9551,
    width: 12.7881,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_1403_19289)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.8059,
    y: 85.4329,
    width: 19.3851,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask37_1403_19289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 86,
    width: 11,
    height: 3
  }, _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7881,
    y: 86.9551,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_1403_19289)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.2061,
    y: 85.4329,
    width: 16.7463,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask38_1403_19289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 86,
    width: 10,
    height: 3
  }, _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 79.6389,
    y: 86.9551,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_1403_19289)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.0566,
    y: 85.4329,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask39_1403_19289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 86,
    width: 10,
    height: 3
  }, _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 96.9939,
    y: 86.9551,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_1403_19289)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.4121,
    y: 85.4329,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask40_1403_19289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 86,
    width: 11,
    height: 3
  }, _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 114.349,
    y: 86.9551,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_1403_19289)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.767,
    y: 85.4329,
    width: 16.7463,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask41_1403_19289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 86,
    width: 9,
    height: 3
  }, _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 138.2,
    y: 86.9551,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_1403_19289)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.618,
    y: 85.4329,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask42_1403_19289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 10,
    width: 62,
    height: 34
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3974 10.0406C70.452 10.0139 70.512 10 70.5727 10H76.565C76.7851 10 76.9635 10.1784 76.9635 10.3985C76.9635 10.6186 76.7851 10.797 76.565 10.797H70.6651L61.1378 15.4645L61.129 15.4688L61.129 15.4687L51.3129 19.9829L40.9303 26.249C40.8383 26.3045 40.7278 26.3205 40.6239 26.2934L30.1597 23.5665L20.0155 29.756C19.953 29.7941 19.8811 29.8143 19.8079 29.8143H15.3985C15.1784 29.8143 15 29.6359 15 29.4158C15 29.1957 15.1784 29.0173 15.3985 29.0173H19.6959L29.889 22.7981C29.9813 22.7418 30.0925 22.7254 30.197 22.7526L40.6623 25.4798L50.9202 19.289C50.9329 19.2813 50.9461 19.2744 50.9596 19.2682L60.7915 14.7467L70.3974 10.0406ZM15.2854 35.3887C15.2854 35.2 15.4383 35.0471 15.627 35.0471H23.9888C24.1774 35.0471 24.3304 35.2 24.3304 35.3887V43.568C24.3304 43.7566 24.1774 43.9095 23.9888 43.9095H15.627C15.4383 43.9095 15.2854 43.7566 15.2854 43.568V35.3887ZM26.0288 28.8619C25.8402 28.8619 25.6873 29.0148 25.6873 29.2034V43.4757C25.6873 43.6643 25.8402 43.8172 26.0288 43.8172H34.3907C34.5793 43.8172 34.7322 43.6643 34.7322 43.4757V29.2034C34.7322 29.0148 34.5793 28.8619 34.3907 28.8619H26.0288ZM36.3151 31.8806C36.3151 31.6919 36.468 31.539 36.6567 31.539H44.7924C44.981 31.539 45.1339 31.6919 45.1339 31.8806V43.5679C45.1339 43.7565 44.981 43.9095 44.7924 43.9095H36.6567C36.468 43.9095 36.3151 43.7565 36.3151 43.5679V31.8806ZM47.0583 25.2615C46.8697 25.2615 46.7167 25.4144 46.7167 25.603V43.5679C46.7167 43.7566 46.8697 43.9095 47.0583 43.9095H55.4201C55.6088 43.9095 55.7617 43.7566 55.7617 43.5679V25.603C55.7617 25.4144 55.6088 25.2615 55.4201 25.2615H47.0583ZM57.3446 20.9872C57.3446 20.7986 57.4975 20.6457 57.6862 20.6457H66.048C66.2366 20.6457 66.3896 20.7986 66.3896 20.9872V43.568C66.3896 43.7566 66.2366 43.9096 66.048 43.9096H57.6862C57.4975 43.9096 57.3446 43.7566 57.3446 43.568V20.9872ZM68.0878 16.0299C67.8992 16.0299 67.7462 16.1828 67.7462 16.3715V43.5681C67.7462 43.7567 67.8992 43.9096 68.0878 43.9096H76.2235C76.4121 43.9096 76.5651 43.7567 76.5651 43.5681V16.3715C76.5651 16.1828 76.4121 16.0299 76.2235 16.0299H68.0878Z",
    fill: "#EDF3F6"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_1403_19289)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.066,
    y: 8.23977,
    width: 65.7392,
    height: 36.2591,
    fill: "currentColor",
    stroke: "#343434",
    strokeWidth: 0.113858
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDataViewGraphmetric, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/data-view-graph&metric.7692f3a3.svg";
export { ForwardRef as ReactComponent };